import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ProfileCompletion from "../ProfileCompletion/ProfileCompletion";
import Wrapper from "./styles/completion-widget-styles";
import qualificationTechniquesType from "./types/qualificationTechniquesType";

const CompletionWidget = ({
  slides,
  user,
  profileImageUrl,
  companySpecialities,
  qualificationTechniques,
  aboutAgent,
  aboutCompany,
}) => {
  const progressItems = [
    { data: slides[0], name: "title image" },
    {
      data: user.avatar,
      name: "profile picture",
      link: "/settings",
    },
    { data: user.location, name: "location" },
    {
      data: user.yearsExperience,
      name: "experience length",
    },
    {
      data: profileImageUrl?.includes("default_company_logo.png")
        ? undefined
        : profileImageUrl,
      name: "company logo",
    },
    {
      data: companySpecialities[0],
      name: "specialities",
    },
    {
      data: qualificationTechniques,
      name: "qualification techniques",
    },
    { data: aboutAgent, name: "about you" },
    { data: aboutCompany, name: "company bio" },
  ];

  return (
    <Wrapper>
      <ProfileCompletion progressItems={progressItems} mobileMargins />
    </Wrapper>
  );
};

CompletionWidget.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  user: PropTypes.shape({
    avatar: PropTypes.string,
    location: PropTypes.string,
    yearsExperience: PropTypes.number,
  }),
  companySpecialities: PropTypes.arrayOf(PropTypes.string).isRequired,
  qualificationTechniques: qualificationTechniquesType.isRequired,
  aboutAgent: PropTypes.string,
  aboutCompany: PropTypes.string,
  logo: PropTypes.string,
};

CompletionWidget.defaultProps = {
  user: PropTypes.shape({
    avatar: PropTypes.isNull,
    location: PropTypes.isNull,
    yearsExperience: PropTypes.isNull,
  }),
  aboutAgent: PropTypes.isNull,
  aboutCompany: PropTypes.isNull,
  logo: null,
};

const mapStateToProps = (state) => ({
  slides: state.agencyProfile.profileData.slides,
  user: state.agencyProfile.profileData.user,
  companySpecialities: state.agencyProfile.profileData.companySpecialities,
  aboutAgent: state.agencyProfile.profileData.aboutAgent,
  aboutCompany: state.agencyProfile.profileData.aboutCompany,
  profileImageUrl: state.agencyProfile.profileData.profileImageUrl,
  qualificationTechniques:
    state.agencyProfile.profileData.qualificationTechniques,
});

export default connect(mapStateToProps, {})(CompletionWidget);
